import * as React from 'react'

const FilterIcon = ({ className }) => {
  return (<>
    <svg width="16" height="16" viewBox="0 0 16 16" className={'docs-icon ' + className} xmlns="http://www.w3.org/2000/svg">
      <path d="M0 2.25C0 1.5625 0.53125 1 1.21875 1H14.75C15.4375 1 16 1.5625 16 2.25C16 2.53125 15.875 2.8125 15.6875 3.03125L10 9.9375V13.9688C10 14.5312 9.5 15 8.9375 15C8.6875 15 8.46875 14.9375 8.28125 14.7812L6.375 13.3125C6.125 13.125 6 12.8438 6 12.5312V9.9375L0.28125 3.03125C0.09375 2.8125 0 2.53125 0 2.25ZM1.21875 2C1.09375 2 1 2.125 1 2.25C1 2.3125 1 2.34375 1.03125 2.40625L6.875 9.4375C6.9375 9.53125 7 9.65625 7 9.75V12.5312L8.875 14C8.90625 14 8.90625 14 8.9375 14C8.96875 14 9 14 9 13.9688V9.75C9 9.65625 9.03125 9.53125 9.09375 9.4375L14.9375 2.40625C14.9688 2.34375 15 2.3125 15 2.25C15 2.125 14.875 2 14.75 2H1.21875Z" />
    </svg>
  </>)
}

export default FilterIcon;